var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletPointIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 15,
    viewBox: "0 0 16.667 15",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35663",
    "data-name": "Group 35663",
    transform: "translate(-1.667 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M13.763,2.5c2.874,0,4.57,1.654,4.57,4.485H14.807v.029a2.89,2.89,0,1,0,0,5.778h3.526v.26c0,2.795-1.7,4.449-4.57,4.449H6.237c-2.874,0-4.57-1.654-4.57-4.449v-6.1c0-2.795,1.7-4.449,4.57-4.449Zm3.948,5.727a.615.615,0,0,1,.622.607v2.109a.622.622,0,0,1-.622.607H14.874a1.755,1.755,0,0,1-1.741-1.329,1.652,1.652,0,0,1,.361-1.377,1.743,1.743,0,0,1,1.313-.616Zm-2.5.975h-.274a.638.638,0,0,0-.45.177.607.607,0,0,0-.187.437.636.636,0,0,0,.637.628h.274a.621.621,0,1,0,0-1.242ZM10.318,5.743h-4.7a.629.629,0,0,0-.637.614.636.636,0,0,0,.637.628h4.7a.621.621,0,1,0,0-1.242Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(3.667 10.5)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPointIcon);
export default __webpack_public_path__ + "static/media/walletPoint-icon.6ae849b9b4a871cec57e75a04cc9bfe0.svg";
export { ForwardRef as ReactComponent };